// Updated Header component - tracking logic removed
import { useState, useEffect, useRef } from "react";
import { LogoHeader, LogoWhite } from "assets/icons/logos";
import favIcon from "../../assets/images/favori.png";
import whiteFavIcon from "../../assets/images/favori-heart-white.png";
import cartIcon from "../../assets/images/ico-shop.svg";
import calendarIcon from "assets/icons/calendarIcon.svg";
import { ReactComponent as CalendarIconSvg } from "assets/icons/calendarIcon.svg";
import { languages } from "./components/LanguageDropdown/constants";
import Sidebar from "./components/Sidebar";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useModal } from "context";
import { selectIsAuthenticated, selectUserType } from "store/auth/selectors";
import { UserWhiteIcon, UserBlackIcon } from "assets/icons";
import { HeaderSearchForm, LanguageDropdown, CTAButton, UserDropdown } from "./components";
import { Login, SignupForm } from "modals";
import styles from "./styles.module.scss";
import { BurgerIcon } from "./headerSvgIcons";

const Header = ({ transparent = false }) => {
  const navigate = useNavigate();
  const { openModal } = useModal();
  const lang = localStorage.getItem("lang");
  const { t, i18n } = useTranslation("global");

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const type = useSelector(selectUserType);

  const { error, loading } = useSelector((state) => state.auth);

  const [navbarIsOpen, setNavbarIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isRegisterDropdownOpen, setIsRegisterDropdownOpen] = useState(false);
  const registerDropdownRef = useRef(null);

  useEffect(() => {
    if (transparent) {
      const handleScroll = () => {
        if (window.scrollY < 150) {
          setIsScrolled(false);
        } else {
          setIsScrolled(true);
        }
      };

      window.addEventListener("scroll", handleScroll);
      handleScroll();

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [transparent]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (registerDropdownRef.current && !registerDropdownRef.current.contains(event.target)) {
        setIsRegisterDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Add this handler in Header component
const handlePhoneClick = () => {
  // Push click event
  window.dataLayer.push({
    event: 'clic_appel_telephone_header',
    call_source: 'header'
  });

  // Set up focus lost tracking
  const handleVisibilityChange = () => {
    if (document.hidden) {
      window.dataLayer.push({
        event: 'call_button_focus_lost',
        call_source: 'header'
      });
    }
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
  
  document.addEventListener('visibilitychange', handleVisibilityChange, { once: true });
  
  // Open phone dialer
  window.location.href = "tel:+330180522522";
};

  const handleIconClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/");
  };

  const useWhiteIcons = transparent && !isScrolled;

  const handleRegisterAsProvider = () => {
    setIsRegisterDropdownOpen(false);
    openModal({
      content: <SignupForm type="provider" />,
      title: t("modal.register.titleProvider"),
    });
  };

  const handleRegisterAsSeeker = () => {
    setIsRegisterDropdownOpen(false);
    openModal({
      content: <SignupForm type="seeker" />,
      title: t("modal.register.titleSeeker"),
    });
  };

  return (
    <div
      className={`pageContainer ${styles.header} ${transparent && !isScrolled ? styles.transparentHeader : ""
        }`}
      id="headerId"
    >
      <div className={styles.headerContainer}>
        <div className={styles.logoAndSearchContainer}>
          <img
            className={styles.logo}
            src={useWhiteIcons ? LogoHeader : LogoHeader}
            alt="logo"
            onClick={handleIconClick}
            style={{
              maxHeight: useWhiteIcons ? "50px" : "50px",
            }}
          />
          {!useWhiteIcons && <div className={styles.searchInputContainer}>
            <HeaderSearchForm />
          </div>}
        </div>
        
        <div className={styles.navigationButtonsMobile}>
          <CTAButton
            variant="icon"
            icon={BurgerIcon}
            type="button"
            onClick={() => setNavbarIsOpen(!navbarIsOpen)}
          >
            <BurgerIcon
              style={{
                color: useWhiteIcons ? "#000" : "#000",
              }}
            />
          </CTAButton>

          <div
            className={`${styles.sidebar} ${navbarIsOpen ? styles.active : styles.inactive
              }`}
          >
            {navbarIsOpen && (
              <Sidebar closeSidebar={() => setNavbarIsOpen(false)} />
            )}
          </div>
        </div>

        <div className={styles.mainButtonsContainer}>
          <CTAButton
            variant="primary"
            onClick={() =>
              openModal({
                content: <SignupForm type="provider" />,
                title: t("modal.register.titleProvider"),
              })
            }
          >
            {t("navbar.rentASpace")}
          </CTAButton>

        <CTAButton
  variant="primary"
  onClick={handlePhoneClick}
  data-testid="call-button"
>
  +33 (0) 1 80 522 522
</CTAButton>

          <LanguageDropdown />

          {isAuthenticated && type === "provider" && (
            <CTAButton
              variant="icon"
              onClick={() => navigate("/calendar/timetable")}
              aria-label="Calendar"
            >
              <CalendarIconSvg
                style={{
                  color: useWhiteIcons ? "#000" : "#000",
                }}
              />
            </CTAButton>
          )}

          {type !== "provider" && (
            <CTAButton
              variant="icon"
              onClick={() => navigate("/basket")}
              aria-label="Cart"
            >
              <img src={cartIcon} alt="cart icon" />
            </CTAButton>
          )}
        </div>

        <div className={styles.authButtonsContainer}>
          {!isAuthenticated ? (
            <>
              <CTAButton
                variant="light"
                onClick={() =>
                  openModal({
                    content: <Login       redirectToDashboard={true} 
/>,
                    title: t("modal.login.title"),
                  })
                }
              >
                {t("navbar.login")}
              </CTAButton>

              {/* Register Button with Dropdown */}
              <div className={styles.registerDropdownWrapper} ref={registerDropdownRef}>
                <CTAButton
                  variant="primary"
                  onClick={() => setIsRegisterDropdownOpen(!isRegisterDropdownOpen)}
                  aria-expanded={isRegisterDropdownOpen}
                  aria-haspopup="true"
                >
                  {t("navbar.register")}
                </CTAButton>
                
                {isRegisterDropdownOpen && (
                  <div className={styles.registerDropdown}>
                    <button
                      className={styles.registerDropdownItem}
                      onClick={handleRegisterAsProvider}
                    >
                      {t("navbar.registerAsProvider") || "Register as Provider"}
                    </button>
                    <button
                      className={styles.registerDropdownItem}
                      onClick={handleRegisterAsSeeker}
                    >
                      {t("navbar.registerAsSeeker") || "Register as Seeker"}
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <UserDropdown useWhiteIcons={useWhiteIcons} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;